/**
 * Injects the subscription promo bar above the BaB modal heading (#modal-title)
 * and overrides Awtomic's injected modal title text.
 */
(function () {
  var TEMPLATE_ID = 'custom-subscription-promo-bab-template';
  var TITLE_SELECTOR =
    '.bundleapp-modal__container--complete-screen--header-container #modal-title';
  var INJECTED_ATTR = 'data-custom-subscription-promo-bab';
  var MODAL_TITLE_TEXT = 'Build a Box';

  function getTemplate() {
    return document.getElementById(TEMPLATE_ID);
  }

  function updateModalTitle(title) {
    if (title && title.textContent !== MODAL_TITLE_TEXT) {
      title.textContent = MODAL_TITLE_TEXT;
    }
  }

  function injectPromo() {
    var title = document.querySelector(TITLE_SELECTOR);
    if (!title || !title.parentNode) return;

    updateModalTitle(title);

    var template = getTemplate();
    if (!template || !template.content) return;

    var header = title.parentNode;
    if (header.querySelector('[' + INJECTED_ATTR + ']')) return;

    var node = template.content.firstElementChild
      ? template.content.firstElementChild.cloneNode(true)
      : null;
    if (!node) return;

    header.insertBefore(node, title);
  }

  function observe() {
    var observer = new MutationObserver(function () {
      injectPromo();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  function init() {
    injectPromo();
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
